// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-container 
{
    position: absolute;
    top: 12%;
    left: 72%;
    width: 26%;

    border-radius: 15px;

    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;

    margin-right: 50px;

    background-color: #00468D;
    transition: 300ms ease;
}

input[type="checkbox"] 
{
    appearance: none;
    -webkit-appearance: none;
    background-color: aliceblue;
    height: 15px;
    width: 15px;
    cursor: pointer;
    border-radius: 10px;
    outline: none;
    margin-right: 10px;
}

input[type="checkbox"]:checked 
{
    background-color: #ecaa1e;
    transition: 300ms ease;
}

input[type="checkbox"]:checked:after 
{
    display: block;
}

.filter-header 
{
    color: white;
    font-size: 22px;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    line-height: 50px;

    margin-left: 35%;
}

.filter-list 
{
    list-style: none;
}

.filter-item 
{
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}

.filter-bubble 
{
    transform: scale(1.3);
}

.filter-text 
{
    color: white;
    font-size: 18px;
    font-family: 'Poppins', sans-serif;
    font-weight: 300;
    line-height: 50px;

    padding-left: 10px;
    cursor: pointer;
}

.filter-buttons 
{
    padding-top: 10px;
    padding-bottom: 20px;
    padding-left: 20px;
}

.filter-submit 
{
    padding: 8px;
}

.filter-reset 
{
    padding: 8px;
}

.filter-system-container 
{
    display: flex;
    flex-direction: row;
    margin-left: 8%;
    margin-right: 8%;
    position: relative;
    justify-content: space-between;
    margin-top: 20px;
    display: none;
}

.filter-category-container 
{
    width: 100%;
    cursor: pointer;
}

.filter-buttons-container 
{
    position: relative;
}

.filter-both-buttons-container 
{
    display: flex;
}

.filter-school-button 
{
    border-radius: 15px;
    padding: 12px 40px;
    cursor: pointer;
    z-index: 1;
    background-color: #001E60;
    color: #fff;
    font-size: 15px;
    font-weight: 300;
    transition: 200ms ease;
}

.filter-school-button:hover 
{
    box-shadow: 0 0 0 1px white;
}


.filter-school-button .arrow 
{
    display: inline-block;
    margin-left: 15px;
}

.school-filter-content 
{
    position: absolute;
    top: 125%;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #001e60f3;
    padding: 20px;
    width: 350px;
    border-radius: 10px;
    z-index: 1;
    overflow-y: scroll;
    -webkit-animation-duration: 0.4s;
    animation-duration: 0.4s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    box-shadow: 0 12px 18px rgba(0, 0, 0, .20);
    cursor: pointer;
}

.category-section 
{
    color: white;
    font-size: 15px;
    padding: 10px 5px;
    display: flex;
    align-items: center;
    border-radius: 10px;
    transition: 300ms ease;
    cursor: pointer;
}

.category-section:hover 
{
    background-color: #00468D;
}

.add-service-button 
{
    border-radius: 15px;
    padding: 12px 40px;
    cursor: pointer;
    z-index: 1;
    background-color: #001E60;
    color: #fff;
    font-size: 15px;
    font-weight: 300;
    margin-right: 50px;
    transition: 200ms ease;
}

.add-service-button:hover 
{
    box-shadow: 0 0 0 1px white;
}

.add-service-button .arrow 
{
    display: inline-block;
    margin-left: 15px;
}

.content 
{
    position: absolute;
    top: 125%;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #001e60f3;
    padding: 20px;
    width: 350px;
    border-radius: 10px;
    z-index: 1;
    overflow-y: scroll;
    -webkit-animation-duration: 0.4s;
    animation-duration: 0.4s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    box-shadow: 0 12px 18px rgba(0, 0, 0, .20);
    cursor: pointer;
}

@media all and (max-width : 1600px) 
{
    .filter-container 
    {
        top: 12%;
        left: 67%;
        width: 30%;
    }

    .filter-text 
    {
        font-size: 17px;
        line-height: 45px;
    }
}

@media all and (max-width : 1050px) 
{
    .filter-school-button
    {
        padding: 12px 20px;
        display: flex;
        align-items: center;
    }

    .add-service-button
    {
        padding: 12px 20px;
        display: flex;
        align-items: center;
    }
}


@media all and (max-width : 988px) 
{
    .filter-system-container
    {
        justify-content: center;
        align-items: center;
        margin-bottom : 20px;
    }
}

*::-webkit-scrollbar {
    width: 8px;
}

*::-webkit-scrollbar-track {
    background: #001E60;
    border-radius: 10px;
}

*::-webkit-scrollbar-thumb {
    background-color: whitesmoke;
    border-radius: 20px;
}

*::-webkit-scrollbar-thumb:hover {
    background-color: #ecaa1e;
}

.details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.collapsible-button {
    background-color: #001E60;
    color: #fff;
    border: none;
    font-weight: 500;
}

.collapsible-button .arrow {
    display: inline-block;
    margin-right: 10px;
}

.details label {
    padding-left: 30px;
    color: #fff;
}

.arrow {
    display: inline-block;
    position: relative;
    top: -2px;
    align-items: center;
    width: 9px;
    height: 9px;
    border-top: 1.5px solid #fff;
    border-right: 1.5px solid #fff;
    margin-left: 8px;
}

.arrow.up {
    transform: rotate(-45deg);
    transition: 300ms ease;
    top: 0px;
}

.arrow.down {
    transform: rotate(135deg);
    transition: 300ms ease;
    top: -3px;
}

.sort-by .arrow {
    border-top: 1.5px solid #000;
    border-right: 1.5px solid #000;
    margin-left: 5px;
    position: relative;
    top: -3px;

}

.cont {
    position: relative;
}


.cont select {
    z-index: 1;
    color: #001E60;
}


.sort-label {
    font-size: 18px;
}


.right-section {
    color: white;
}


@media all and (max-width: 850px) 
{
    .filter-school-button
    {
        padding: 12px 40px;
    }

    .add-service-button
    {
        padding: 12px 40px;
    }

    .dropdown-container 
    {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        max-width: 100%;
        padding: 10px;
    }

    .add-service-button 
    {
        text-align: left; 
    }

    .content 
    {
        position: static;
        width: 100%;
        margin-top: 10px;
        height: auto;
        overflow-y: visible;
    }

    .details label 
    {
        padding-left: 0;
    }

    .sort-by 
    {
        flex-direction: column;
        align-items: flex-start;
    }

    .sort-by .arrow 
    {
        margin-left: 0;
        margin-top: 5px;
    }

    .search-result-container
    {
        padding-top: 120px;
    }

    .category-section 
    {
        padding: 10px 10px;
    }
}

@media all and (max-width: 480px) 
{
    .content 
    {
        position: static;
        margin-top: 10px;
        height: auto;
        overflow-y: visible;
        width: 100vw;
        border-radius: 0px;
    }

    .mobileFilterServiceButton 
    {
        width: 100%;
        text-align: center;
    }

    .filter-school-button
    {
        padding: 10px 30px;
        font-size: 14px;
    }

    .add-service-button
    {
        padding: 10px 40px;
        font-size: 14px;
        margin-right: 0px;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/explore-services/service-filter.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;;IAEV,mBAAmB;;IAEnB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;;IAEnB,kBAAkB;;IAElB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;IAChB,wBAAwB;IACxB,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;;IAEjB,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;;IAEjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;AACjB;;AAEA;;IAEI,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;IAEI,2BAA2B;AAC/B;;;AAGA;;IAEI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,gCAAgC;IAChC,wBAAwB;IACxB,iCAAiC;IACjC,yBAAyB;IACzB,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,gCAAgC;IAChC,wBAAwB;IACxB,iCAAiC;IACjC,yBAAyB;IACzB,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;;IAEI;;QAEI,QAAQ;QACR,SAAS;QACT,UAAU;IACd;;IAEA;;QAEI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;;QAEI,kBAAkB;QAClB,aAAa;QACb,mBAAmB;IACvB;;IAEA;;QAEI,kBAAkB;QAClB,aAAa;QACb,mBAAmB;IACvB;AACJ;;;AAGA;;IAEI;;QAEI,uBAAuB;QACvB,mBAAmB;QACnB,oBAAoB;IACxB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;;AAEb;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,UAAU;IACV,cAAc;AAClB;;;AAGA;IACI,eAAe;AACnB;;;AAGA;IACI,YAAY;AAChB;;;AAGA;;IAEI;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,eAAe;QACf,aAAa;IACjB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;QAChB,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,mBAAmB;IACvB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;;QAEI,cAAc;QACd,eAAe;IACnB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI;;QAEI,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;QACZ,mBAAmB;QACnB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;;QAEI,WAAW;QACX,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;;QAEI,kBAAkB;QAClB,eAAe;QACf,iBAAiB;IACrB;;AAEJ","sourcesContent":[".filter-container \n{\n    position: absolute;\n    top: 12%;\n    left: 72%;\n    width: 26%;\n\n    border-radius: 15px;\n\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 10px;\n    padding-right: 10px;\n\n    margin-right: 50px;\n\n    background-color: #00468D;\n    transition: 300ms ease;\n}\n\ninput[type=\"checkbox\"] \n{\n    appearance: none;\n    -webkit-appearance: none;\n    background-color: aliceblue;\n    height: 15px;\n    width: 15px;\n    cursor: pointer;\n    border-radius: 10px;\n    outline: none;\n    margin-right: 10px;\n}\n\ninput[type=\"checkbox\"]:checked \n{\n    background-color: #ecaa1e;\n    transition: 300ms ease;\n}\n\ninput[type=\"checkbox\"]:checked:after \n{\n    display: block;\n}\n\n.filter-header \n{\n    color: white;\n    font-size: 22px;\n    font-family: 'Poppins', sans-serif;\n    font-weight: 400;\n    line-height: 50px;\n\n    margin-left: 35%;\n}\n\n.filter-list \n{\n    list-style: none;\n}\n\n.filter-item \n{\n    padding-top: 8px;\n    padding-bottom: 8px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.filter-bubble \n{\n    transform: scale(1.3);\n}\n\n.filter-text \n{\n    color: white;\n    font-size: 18px;\n    font-family: 'Poppins', sans-serif;\n    font-weight: 300;\n    line-height: 50px;\n\n    padding-left: 10px;\n    cursor: pointer;\n}\n\n.filter-buttons \n{\n    padding-top: 10px;\n    padding-bottom: 20px;\n    padding-left: 20px;\n}\n\n.filter-submit \n{\n    padding: 8px;\n}\n\n.filter-reset \n{\n    padding: 8px;\n}\n\n.filter-system-container \n{\n    display: flex;\n    flex-direction: row;\n    margin-left: 8%;\n    margin-right: 8%;\n    position: relative;\n    justify-content: space-between;\n    margin-top: 20px;\n    display: none;\n}\n\n.filter-category-container \n{\n    width: 100%;\n    cursor: pointer;\n}\n\n.filter-buttons-container \n{\n    position: relative;\n}\n\n.filter-both-buttons-container \n{\n    display: flex;\n}\n\n.filter-school-button \n{\n    border-radius: 15px;\n    padding: 12px 40px;\n    cursor: pointer;\n    z-index: 1;\n    background-color: #001E60;\n    color: #fff;\n    font-size: 15px;\n    font-weight: 300;\n    transition: 200ms ease;\n}\n\n.filter-school-button:hover \n{\n    box-shadow: 0 0 0 1px white;\n}\n\n\n.filter-school-button .arrow \n{\n    display: inline-block;\n    margin-left: 15px;\n}\n\n.school-filter-content \n{\n    position: absolute;\n    top: 125%;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    background-color: #001e60f3;\n    padding: 20px;\n    width: 350px;\n    border-radius: 10px;\n    z-index: 1;\n    overflow-y: scroll;\n    -webkit-animation-duration: 0.4s;\n    animation-duration: 0.4s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n    box-shadow: 0 12px 18px rgba(0, 0, 0, .20);\n    cursor: pointer;\n}\n\n.category-section \n{\n    color: white;\n    font-size: 15px;\n    padding: 10px 5px;\n    display: flex;\n    align-items: center;\n    border-radius: 10px;\n    transition: 300ms ease;\n    cursor: pointer;\n}\n\n.category-section:hover \n{\n    background-color: #00468D;\n}\n\n.add-service-button \n{\n    border-radius: 15px;\n    padding: 12px 40px;\n    cursor: pointer;\n    z-index: 1;\n    background-color: #001E60;\n    color: #fff;\n    font-size: 15px;\n    font-weight: 300;\n    margin-right: 50px;\n    transition: 200ms ease;\n}\n\n.add-service-button:hover \n{\n    box-shadow: 0 0 0 1px white;\n}\n\n.add-service-button .arrow \n{\n    display: inline-block;\n    margin-left: 15px;\n}\n\n.content \n{\n    position: absolute;\n    top: 125%;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    background-color: #001e60f3;\n    padding: 20px;\n    width: 350px;\n    border-radius: 10px;\n    z-index: 1;\n    overflow-y: scroll;\n    -webkit-animation-duration: 0.4s;\n    animation-duration: 0.4s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n    box-shadow: 0 12px 18px rgba(0, 0, 0, .20);\n    cursor: pointer;\n}\n\n@media all and (max-width : 1600px) \n{\n    .filter-container \n    {\n        top: 12%;\n        left: 67%;\n        width: 30%;\n    }\n\n    .filter-text \n    {\n        font-size: 17px;\n        line-height: 45px;\n    }\n}\n\n@media all and (max-width : 1050px) \n{\n    .filter-school-button\n    {\n        padding: 12px 20px;\n        display: flex;\n        align-items: center;\n    }\n\n    .add-service-button\n    {\n        padding: 12px 20px;\n        display: flex;\n        align-items: center;\n    }\n}\n\n\n@media all and (max-width : 988px) \n{\n    .filter-system-container\n    {\n        justify-content: center;\n        align-items: center;\n        margin-bottom : 20px;\n    }\n}\n\n*::-webkit-scrollbar {\n    width: 8px;\n}\n\n*::-webkit-scrollbar-track {\n    background: #001E60;\n    border-radius: 10px;\n}\n\n*::-webkit-scrollbar-thumb {\n    background-color: whitesmoke;\n    border-radius: 20px;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n    background-color: #ecaa1e;\n}\n\n.details {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.collapsible-button {\n    background-color: #001E60;\n    color: #fff;\n    border: none;\n    font-weight: 500;\n}\n\n.collapsible-button .arrow {\n    display: inline-block;\n    margin-right: 10px;\n}\n\n.details label {\n    padding-left: 30px;\n    color: #fff;\n}\n\n.arrow {\n    display: inline-block;\n    position: relative;\n    top: -2px;\n    align-items: center;\n    width: 9px;\n    height: 9px;\n    border-top: 1.5px solid #fff;\n    border-right: 1.5px solid #fff;\n    margin-left: 8px;\n}\n\n.arrow.up {\n    transform: rotate(-45deg);\n    transition: 300ms ease;\n    top: 0px;\n}\n\n.arrow.down {\n    transform: rotate(135deg);\n    transition: 300ms ease;\n    top: -3px;\n}\n\n.sort-by .arrow {\n    border-top: 1.5px solid #000;\n    border-right: 1.5px solid #000;\n    margin-left: 5px;\n    position: relative;\n    top: -3px;\n\n}\n\n.cont {\n    position: relative;\n}\n\n\n.cont select {\n    z-index: 1;\n    color: #001E60;\n}\n\n\n.sort-label {\n    font-size: 18px;\n}\n\n\n.right-section {\n    color: white;\n}\n\n\n@media all and (max-width: 850px) \n{\n    .filter-school-button\n    {\n        padding: 12px 40px;\n    }\n\n    .add-service-button\n    {\n        padding: 12px 40px;\n    }\n\n    .dropdown-container \n    {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        max-width: 100%;\n        padding: 10px;\n    }\n\n    .add-service-button \n    {\n        text-align: left; \n    }\n\n    .content \n    {\n        position: static;\n        width: 100%;\n        margin-top: 10px;\n        height: auto;\n        overflow-y: visible;\n    }\n\n    .details label \n    {\n        padding-left: 0;\n    }\n\n    .sort-by \n    {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .sort-by .arrow \n    {\n        margin-left: 0;\n        margin-top: 5px;\n    }\n\n    .search-result-container\n    {\n        padding-top: 120px;\n    }\n\n    .category-section \n    {\n        padding: 10px 10px;\n    }\n}\n\n@media all and (max-width: 480px) \n{\n    .content \n    {\n        position: static;\n        margin-top: 10px;\n        height: auto;\n        overflow-y: visible;\n        width: 100vw;\n        border-radius: 0px;\n    }\n\n    .mobileFilterServiceButton \n    {\n        width: 100%;\n        text-align: center;\n    }\n\n    .filter-school-button\n    {\n        padding: 10px 30px;\n        font-size: 14px;\n    }\n\n    .add-service-button\n    {\n        padding: 10px 40px;\n        font-size: 14px;\n        margin-right: 0px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
